import Game_UI from "./Game_UI.js";
import Game from "./Game.js";
import gameData from "../../gameData.js";
import Game_Ruler from "./Game_Ruler.js";
import ABCyaLib from "@abcya/abcya_lib";
import ABCyaPhaser from "@abcya/abcya_phaser";

export default class Game_SnakeMenu
{
    /**
     * @param {Game} scene 
     * @param {Game_UI} parent 
     */
    constructor(scene, ui)
    {
        this.scene = scene;
        this.ui = ui;

        this.onNumberSubmitted = null;

        if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){
          this.hundredsSnake_Button = this.createButton(170, 315, 100, 4);
          this.tensSnake_Button = this.createButton(58, 350, 10, 9);
          this.onesSnake_Button = this.createButton(58, 240, 1, 9);
        }
        else{
          this.tensSnake_Button = this.createButton(115, 331, 10, 9);
          this.onesSnake_Button = this.createButton(185, 332, 1, 9);
        }


        this.snakes_1 = [];
        this.snakes_10 = [];
        this.snakes_100 = [];

        this.ruler = new Game_Ruler(this.scene);
        if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){
          this.numberLine_Graphic = this.scene.addImage(150, 488, "make_numberline");
        }
        else{
          // this.numberLine_Graphic = this.scene.addImage(150, 488, "make_numberline");

          const text1 = {x: 115, y: 490};
          const text2 = {x: 185, y: 490};

          this.scene.addText(text1.x, text1.y, "tens", 17, null, 1, this.scene, "Kom").tint = 0x61352E;
          this.scene.addText(text2.x, text1.y, "ones", 17, null, 1, this.scene, "Kom").tint = 0x61352E;
          this.scene.addText(text1.x, text1.y - 19, "____", 25, null, 1, this.scene, "Kom").tint = 0x61352E;
          this.scene.addText(text2.x, text1.y - 19, "____", 25, null, 1, this.scene, "Kom").tint = 0x61352E;

        }
        this.submitButton = this.scene.addButton(150, 560, "BTN_submitOff", {frameOnDown: "BTN_submitOn"}, ()=>{
            this.onNumberSubmitted(this.curNumber);
        });

        if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){

          this.hundreds_Text = this.scene.addText(87, 462, "0", 45, null, 1, this.scene, "Kom");
          this.hundreds_Text.tint = 0x61352E;
          this.tens_Text = this.scene.addText(155, 462, "0", 45, null, 1, this.scene, "Kom");
          this.tens_Text.tint = 0x61352E;
          this.ones_Text = this.scene.addText(220, 462, "0", 45, null, 1, this.scene, "Kom");
          this.ones_Text.tint = 0x61352E;
        }
        else{
          this.tens_Text = this.scene.addText(115, 462, "0", 45, null, 1, this.scene, "Kom");
          this.tens_Text.tint = 0x61352E;
          this.ones_Text = this.scene.addText(185, 462, "0", 45, null, 1, this.scene, "Kom");
          this.ones_Text.tint = 0x61352E;
        }

        this.tensLocked = true;
        this.hundredsLocked = true;

        this.curNumber = 0;
    }

    setUnits(units) //WE NEED TO CHECK THIS METHOD MORE!!!!!!!!!
    {
        this.ruler.setRuler(units);

        this.tensLocked = (units < 10);
        this.hundredsLocked = (units < 100);

        this.refreshSnakeCount();
    }

    createButton(x, y, units, maxQuantity)
    {
        let button = this.scene.addImage(x, y, (gameData.curSnakeIndex+1) + "_scribble" + units);
        button.setInteractive();
        button.maxQuantity = maxQuantity;
        button.on("pointerdown", ()=>{
            this.scene.createSnake(units, true);
            this.refreshSnakeCount();
        });
        return button;
    }

    reset()
    {
        this.curNumber = 0;
        this.refreshSnakeCount();
        this.refreshButtonImages();
    }

    refreshButtonImages()
    {
      if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){

        this.hundredsSnake_Button.setFrame((gameData.curSnakeIndex+1) + "_scribble100", false, false);
      }
      this.tensSnake_Button.setFrame((gameData.curSnakeIndex+1) + "_scribble10", false, false);
      this.onesSnake_Button.setFrame((gameData.curSnakeIndex+1) + "_scribble1", false, false);
    }

    refreshSnakeCount()
    {
        this.snakes_1 = [];
        this.snakes_10 = [];
        this.snakes_100 = [];

        let snakes = this.scene.snakes;

        for (let i = 0; i < snakes.length; i++) {
            if (snakes[i].units == 1) {
                this.snakes_1.push(snakes[i]);
            }
            else if (snakes[i].units == 10) {
                this.snakes_10.push(snakes[i]);
            }
            else {
                this.snakes_100.push(snakes[i]);
            }
        }

        this.checkButton(this.onesSnake_Button, this.snakes_1, false);
        this.checkButton(this.tensSnake_Button, this.snakes_10, this.tensLocked);
        if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){
          this.checkButton(this.hundredsSnake_Button, this.snakes_100, this.hundredsLocked);
        }

        this.curNumber = this.snakes_100.length * 100 + this.snakes_10.length * 10 + this.snakes_1.length;

        this.ruler.setAmount(this.curNumber);
        this.ones_Text.text = this.snakes_1.length;
        this.tens_Text.text = this.snakes_10.length;
        if(ABCyaLib.Environment.instance.gameConfig.hundredsFill === true){

          this.hundreds_Text.text = this.snakes_100.length;
        }
    }

    checkButton(button, snakeArr, isLocked)
    {
        if (snakeArr.length >= button.maxQuantity || isLocked) {
            button.tint = 0xaaaaaa;
            button.disableInteractive();
        } else {
            button.tint = 0xffffff;
            button.setInteractive();
        }
    }
}